// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5341dbfb","102":"d5b48cc0","365":"38b4ebbb","713":"c4082433"}[chunkId] + ".chunk.js";
};